import React, { FormEvent, ReactElement } from 'react';
import {
  FormGroup, Input,
  Label, LoaderButton, Textarea,
}
  from 'idsk-react-components';
import { SafeParameterSetter } from '../../../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../../../model/PrispevokVestnikaStepEnum';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading?: boolean;
  getFieldErrorMessage: (fieldName: string) => string;
}

const BasicDataStep1Component = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading = false,
  getFieldErrorMessage,
}: Props): ReactElement => (
  <>
    <FormGroup error={!!getFieldErrorMessage('nazov')}>
      <Label htmlFor="nazov">Názov príspevku</Label>
      <Textarea
        className="idsk-!-width-three-quarters"
        showRemaining
        rows={3}
        expandHeight
        id="nazov"
        type="text"
        maxLength={254}
        name="nazov"
        value={prispevokVestnika.nazov}
        onChange={({ target }) => onUpdateField('nazov', target.value)}
        error={getFieldErrorMessage('nazov')}
        autoComplete="off"
      />
    </FormGroup>
    <FormGroup error={!!getFieldErrorMessage('kratkyNazov')}>
      <Label htmlFor="kratkyNazov">
        Krátky názov príspevku <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Label>
      <Input
        id="kratkyNazov"
        width="full"
        type="text"
        maxLength={254}
        name="kratkyNazov"
        value={prispevokVestnika.kratkyNazov}
        onChange={({ target }) => onUpdateField('kratkyNazov', target.value)}
        error={getFieldErrorMessage('kratkyNazov')}
        autoComplete="off"
      />
    </FormGroup>
    <FormGroup error={!!getFieldErrorMessage('cislo')}>
      <Label htmlFor="cislo">Číslo príspevku</Label>
      <Input
        id="cislo"
        width="one-third"
        type="text"
        maxLength={254}
        name="cislo"
        value={prispevokVestnika.cislo}
        onChange={({ target }) => onUpdateField('cislo', target.value)}
        error={getFieldErrorMessage('cislo')}
        autoComplete="off"
      />
    </FormGroup>
    <LoaderButton
      size="large"
      loading={loading}
      type="submit"
      onClick={(e) => onSubmit(e, PrispevokVestnikaStepEnum.DATES_2)}
    >Pokračovať
    </LoaderButton>
  </>
);

export default BasicDataStep1Component;
